import { render, staticRenderFns } from "./show-questionOfPapers.vue?vue&type=template&id=4f0bcd8c&"
import script from "./show-questionOfPapers.vue?vue&type=script&lang=ts&"
export * from "./show-questionOfPapers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports